import Api from "../../../util/Api";

export default function getInitState() {
    return {
        staffFormIsOpen: false,
        staffGridIsOpen: true,
        staffActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új személyzet',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newStaffRow'
            }
        ],
        staffFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToStaffGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetStaffForm'
            }
        ],
        staffRowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyStaffRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyStaffRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteStaffRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteStaffRow'
            }
        ],
        staffHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "fullName",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "title",
                label: "Titulus",
                visibility: false,
                formVisible: false
            },
            {
                name: "identityCardNumber",
                label: "Személyi igazolvány száma",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "lastName",
                label: "Vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "firstName",
                label: "Keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "nationality",
                label: "Állampolgárság",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "sex",
                label: "Nem",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "employeeState",
                label: "Állapot",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getStaffEmployeeStates,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "motherName",
                label: "Anyja neve",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "birthLastName",
                label: "Születési vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "birthFirstName",
                label: "Születési keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "placeOfBirth",
                label: "Születési hely",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: "text",
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                formType: 'date',
                slot_name: "date_format",
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "isRetired",
                label: "Nyugdíjas",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [{id: '0', text: 'Nem'}, {id: '1', text: 'Igen'}],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "deleted",
                label: "Státusz",
                filter: {
                    type: "simple",
                },
                slot_name: "deleted_format",
                visibility: true,
            },
            {
                name: "userId",
                label: "Felhasználó",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getNurseUsers, //jogosultságok úgyis meg fognak változni ezért ezt benne hagyom később majd át kell írni
                    formatText: function (val) {
                        return val.username;
                    },
                    formatOption: function (val) {
                        return val.username;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'username',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true
            },
            {
                name: "companyId",
                label: "Cég azonosító",
                visibility: false,
            },
            {
                name: "siteId",
                label: "Telephely azonosító",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "employeeType",
                label: "Dolgozó típus",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],

        educationFormIsOpen: false,
        educationGridIsOpen: true,
        educationActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új képzettség',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newEducationRow'
            }
        ],
        educationFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEducationGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetEducationForm'
            }
        ],
        educationRowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyEducationRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyEducationRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteEducationRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteEducationRow'
            }
        ],
        educationHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
            },
            {
                name: "staffId",
                label: "staffId",
                visibility: false,
            },
            {
                name: "name",
                label: "Képzettség neve",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: "text",
                formRequired: true,
                formSize: 4,
                formVisible: true
            },
            {
                name: "startDate",
                label: "Képzés kezdete",
                slot_name: "educationStartDate_format",
                visibility: true,
                formType: "date",
                formRequired: true,
                formSize: 4,
                formVisible: true
            },
            {
                name: "endDate",
                label: "Képzés vége",
                slot_name: "educationEndDate_format",
                visibility: true,
                formType: "date",
                formRequired: true,
                formSize: 4,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        companyFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToStaffGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetStaffCompanyForm'
            }
        ],
        companyHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
                formVisible: false
            },
            {
                name: "companyName",
                label: "Cégnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "siteAddress",
                label: "Telephely címe",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "bankAccountNumber",
                label: "Bankszámlaszám",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
                formVisible: false
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            }
        ],

        feeFormIsOpen: false,
        feeGridIsOpen: true,
        feeActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új díjazás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newFeeRow'
            }
        ],
        feeFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToFeeGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetFeeForm'
            }
        ],
        feeRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyFeeRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteFeeRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteFeeRow'
            }
        ],
        feeHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
            },
            {
                name: "amount",
                label: "Összeg",
                visibility: true,
                slot_name: "commission_format2",
                formType: "number",
                formRequired: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "percent",
                label: "Százalék",
                visibility: false,
                formVisible: false
            },
            {
                name: "comment",
                label: "Megjegyzés",
                visibility: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ]
    }
}
